if (!customElements.get('nav-modal')) {
  class NavModal extends ModalDialog {
    constructor() {
      super();

      this.dialogHolder = this.querySelector('[role="dialog"]');
      document
        .querySelector(`#ModalClose-${this.id}`)
        .addEventListener('click', this.hide.bind(this, false));
      this.addEventListener('keyup', (event) => {
        if (event.code?.toUpperCase() === 'ESCAPE') this.hide();
      });
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }

    show() {
      super.show();
      const header = document.querySelector('.header');
      document.body.classList.add('nav-is-opened');
      document.body.style.setProperty(
        '--header-height',
        `${header.offsetHeight / 10}rem`,
      );

      setTimeout(() => {
        trapFocus(this, this.dialogHolder);
      }, 100);
    }

    hide() {
      super.hide();
      document.body.classList.remove('nav-is-opened');
    }
  }

  customElements.define('nav-modal', NavModal);
}
